import React, { PureComponent } from 'react';
import './index.scss';
import { Toast } from 'antd-mobile';
import Prize from '@/components/Prize';
import CommonModal from '@/components/CommonModal';
import { isLogged, trackPVByActivity, trackClickByActivity } from '@/utils/util';
import { videoActivityStatus, videoSubjectInfo, videoDraw } from '@/services/api';
import emitter from '@/utils/events';
export default class DrawContainer extends PureComponent {
  state = {
    chance: 0,
    playing: false,
    noPrizeModalVisible: false,
    showPrizeModal: false,
    prizeData: {
      winPrizeId: '',
      prizeInfo: [], // 奖品具体信息
      prizeDesc: '', // 客服电话 
      title: '',
      instructionTitle: '', // 奖品说明标题
      instructionDesc: '' // 奖品说明内容
    },
  }
  componentDidMount() {
    trackPVByActivity('20190903_1')
    this.fetchInfo();
    this.eventEmitter = emitter.addListener('fetchDrawInfo', ()=>{
      this.fetchInfo()
    })
  }

  componentWillUnmount(){
    if(this.eventEmitter){
      emitter.removeListener(this.eventEmitter);
   }
  }
  fetchInfo = async () => {
    const { activityEnded } = this.props;
    const res = await videoActivityStatus();

    if(res.code !== 0){
      this.setState({activityMessage: res.errmsg ||'oops,活动异常'})
      return;
    }
    const { status } = res.data;
    if(status === 0 ) {
      this.setState({activityMessage: '活动暂未开始, 敬请期待'})
    }
    if (status === 2) {
      this.setState({activityMessage: activityEnded || '活动已结束'})
      Toast.info(activityEnded || '活动已结束');
      return;
    }
    const token = await isLogged()
    if (token) {
      const subjectInfo = await videoSubjectInfo();
      const { chance, isWatchedVideo, isShared, enableWatchVideo, enableShare } = subjectInfo.data;
      console.log('emitter draw container isWatchedVideo,enableWatchVideo',isWatchedVideo,enableWatchVideo )
      emitter.emit('WatchedVideoForChance', {isWatchedVideo, enableWatchVideo});
      emitter.emit('SharedForChance', {isShared, enableShare});
      this.setState({
        chance, playing: false,
        noPrizeModalVisible: false,
        showPrizeModal: false,
        prizeData: {
          winPrizeId: '',
          prizeInfo: [], // 奖品具体信息
          prizeDesc: '', // 客服电话 
          title: '',
          instructionTitle: '', // 奖品说明标题
          instructionDesc: '' // 奖品说明内容
        },
      })
    }
  }

  draw = async () => {
    console.log('this draw')
    const token = await isLogged() 
    if(!token){
      window.crgt.router.openLogin().then((res) => {
        if (res && res.code === 0) {
          window.location.reload();
        }
      });
      return;
    }
    const { noChanceForDraw } = this.props;
    const { chance = 0, playing, activityMessage } = this.state;
    console.log('activityMessage',activityMessage)
    if(!_.isEmpty(activityMessage)){
      Toast.info(activityMessage);
      return;
    }
    if (playing) {
      return;
    }
    if (chance <= 0) {
      Toast.info(noChanceForDraw || '今日抽奖次数用完啦')
      return;
    }
    
    trackClickByActivity('20190903_2')
    const res = await videoDraw();
    if(res.code !== 0){
      this.setState({playing: false})
      return;
    }
    // 动画效果
    this.setState({ playing: true }, this.showAnimation);
    
    setTimeout(() => this.initPrizeModal(res), 3200);
  }

  initPrizeModal = (res) => {
    const { winPrizeId, title, getPrize, prizeType, prizeDesc, prizeInfo, instructionTitle, instructionDesc } = res.data;
    if (!!getPrize) {
      trackClickByActivity('20190903_6');
    }
    this.setState({
      showPrizeModal: !!getPrize,
      noPrizeModalVisible: getPrize === false,
      prizeData: {
        title,
        prizeType,
        prizeDesc,
        prizeInfo,
        instructionTitle,
        instructionDesc,
        winPrizeId
      }
    })
  }
  showAnimation = () => {
    const focusAni = document.getElementById('focusAni');
    let i = 1;
    this.interval = setInterval((res) => {
      if (i < 20) {
        console.log('timeout i', i)
        if (i > 1) { focusAni.classList.remove(`a${((i - 1) % 8) + 1}`) }
        if(i === 19){focusAni.classList.add(`a9`)}
        else {focusAni.classList.add(`a${(i % 8) + 1}`)}
         i = i + 1;
     } else {
        clearInterval(this.interval);
        this.setState({ playing: false })
      }
    }, 150);

  }
  getModalContent() {
    const { noPrizeBgUrl, noPrizeTextImg, drawModalFontColor, drawModalButtonImgUrl } = this.props;
    let renderHtml = '';
    renderHtml = (
      <div className="no-prize-modal-container" style={{ color: drawModalFontColor }}>
        <div className="no-prize-modal-title">好遗憾， 未中奖！</div>
        <div className="no-prize-modal-content" style={{ backgroundImage: `url(${noPrizeBgUrl})` }}>
          <div className="no-prize-modal-fail"></div>
          <div className="no-prize-modal-text" style={{ backgroundImage: `url(${noPrizeTextImg})` }}></div>
        </div>
        <div className="no-prize-modal-button" style={{ backgroundImage: `url(${drawModalButtonImgUrl})` }} onClick={this.fetchInfo}></div>
      </div>
    )
    return renderHtml;
  }

  closeNoPrizeModal = () => {
    this.setState({ noPrizeModalVisible: false });
    this.fetchInfo();
  }

  closePrizeModal = () => {
    this.setState({ showPrizeModal: false });
    this.fetchInfo();
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }
  render() {
    const { drawContainerBgImgUrl, modalBgColor, focusImgUrl } = this.props;
    const { playing, noPrizeModalVisible, showPrizeModal, prizeData } = this.state
    console.log('draw', showPrizeModal, prizeData)
    return (
      <div className="draw-container" style={{backgroundImage: drawContainerBgImgUrl && `url(${drawContainerBgImgUrl})`}}>
        {playing && <div id="focusAni" className="draw-focus" style={{ backgroundImage: focusImgUrl && `url(${focusImgUrl})` }}></div>}
        <div className="draw-content">
          {this.props.children.map((Component, index) => {
            const { props = {}, } = Component;
            const { id } = props;
            const newProps = {
              ...this.props,
              ...props,
              ...prizeData,
              showPrizeModal,
              closePrizeModal: () => this.closePrizeModal()
            }
            if (index === 4) {
              return (<div onClick={this.draw}><Prize key={id} {...newProps} /></div>)
            }
            else return <Prize key={id} {...newProps} />
          })}

        </div>
        <CommonModal closeBtn visible={noPrizeModalVisible && !playing} modalBgColor={modalBgColor} onClose={this.closeNoPrizeModal} >{this.getModalContent()}</CommonModal>
      </div>
    )
  }
}